import * as React from 'react';

import i18n from 'helper/i18n';

import { getAwardLabel } from 'components/atoms/Award';
import { FAME_BADGE_DEFAULT_TITLES, FAME_BADGE_MODIFIERS } from 'components/molecules/Fame/Badge';
import { FameBadgeProps } from 'components/molecules/Fame/Badge/FameBadge';
import { FameProcessModifier } from 'components/molecules/Fame/Progress/FameProgress';
import { FameProcessModifierType } from 'components/molecules/Fame/Progress/FameProgress';
import Rich from 'components/molecules/Rich';
import FameBadge from 'containers/molecules/Fame/Badge/FameBadge';

export const FAME_ROW_UNITS_UNITS = {
	days: 'days',
	kg: 'kg',
	points: 'points',
};

// TODO: FIX THIS SH**
// export const enum FameRowUnits {
// 	days = 'days',
// 	kg = 'kg',
// 	points = 'points'
// }

export type FameRowUnitType = /*FIXME:F2TS*/ keyof typeof FAME_ROW_UNITS_UNITS;

export type FameRowProps = {
	intro?: string;
	topic: FameProcessModifierType;
	unit?: FameRowUnitType;
	badges?: Array<FameBadgeProps>;
	current: number;
	max: number;
};

const hasPlaceholder = (badges: Array<Object>): boolean => {
	return !!(badges && badges.length === 2);
};

export const getFallbackText = (
	topic: FameProcessModifierType,
	unit: FameRowUnitType,
	threshold: number | string
): string => {
	const pluralization: number = typeof threshold === 'number' ? threshold : 0;
	if (topic === FameProcessModifier.overall) {
		const secureUnit: FameRowUnitType = unit ? (FAME_ROW_UNITS_UNITS[unit] as any) : FAME_ROW_UNITS_UNITS.points;
		return i18n(
			`react.impulsCoach.components.fame.row.badgeNotReachedText.${topic}.${secureUnit}`,
			null,
			pluralization
		);
	}
	return i18n(`react.impulsCoach.components.fame.row.badgeNotReachedText.${topic}`, null, pluralization);
};

export const getBadgeThreshold = (badge: { attributes?: { threshold?: string | number } }): number | string => {
	if (!badge || !badge.attributes) {
		return FAME_BADGE_DEFAULT_TITLES.EMPTY;
	}
	const threshold: number = parseInt(`${badge.attributes.threshold}`, 10);
	return isNaN(threshold) ? FAME_BADGE_DEFAULT_TITLES.EMPTY : threshold;
};

const renderBadges = (badges, topic, unit) => {
	let renderedBadges: any[] = [];
	const classNames = ['m-fame-row__badges-list'];
	if (badges) {
		renderedBadges = badges.map((badge, index) => {
			const badgeThreshold = getBadgeThreshold(badge);
			return (
				<li key={index} className="m-fame-row__badge-item">
					<a
						className="m-fame-row__badge js-ui-overlay"
						href={(badge as any).award ? `#notification-badge` : `#notification-badge-empty`}
						onClick={(ev: React.MouseEvent<any>) => ev.preventDefault()}
					>
						<FameBadge
							label={getAwardLabel('badge', 'title', badge as any)}
							topic={topic}
							modifier={FAME_BADGE_MODIFIERS.PROGRESS}
							award={badge}
							fallback={{
								text: getFallbackText(topic, unit, badgeThreshold),
								title: badgeThreshold,
							}}
						/>
					</a>
				</li>
			);
		});

		if (hasPlaceholder(badges)) {
			classNames.push('m-fame-row__badges-list--placeholder');
			renderedBadges.push(
				<li key="placeholder" className="m-fame-row__badge-item">
					<span className="m-fame-row__badge">&nbsp;</span>
				</li>
			);
		}
	}

	return <ul className={classNames.join(' ')}>{renderedBadges}</ul>;
};

const FameRow = ({ intro, badges, topic, unit }: FameRowProps) => {
	return (
		<div className={`m-fame-row${intro ? ' m-fame-row--intro' : ''}`}>
			<div className="container container--full-width-xs">
				<div className="row">
					<div className="col-xs-12">
						{intro && (
							<div className="m-fame-row__intro">
								<div className="m-fame-row__text">
									<Rich contents={intro} />
								</div>
							</div>
						)}
						<div className="m-fame-row__badges">{badges && renderBadges(badges, topic, unit)}</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default FameRow;
